/*
 * Kits do app Bundlex no formato da proposta A (passo a passo, como na Insider).
 *
 * Dois tipos de oferta do app viram o mesmo passo a passo:
 * - kit da mesma peca ("Descontos por quantidade"): o app imprime N linhas de
 *   cor e tamanho (.bx-variant-group) de uma vez; cada linha e uma peca;
 * - pacote de produtos diferentes ("Pacote fixo"): o app imprime um bloco
 *   .bx-bundle-products com um .bx-cross-sell-item por produto (foto, nome,
 *   preco e as listas de cor e tamanho); cada produto e uma peca.
 * Em cima disso este script:
 * - escreve o cabecalho "Compre em kit: 3 pecas · 10% OFF" e os cards
 *   "Kit 3 pecas / R$ 179,10/un" com o selo "10% OFF" no canto, calculados
 *   pelos precos que o proprio app mostra (os textos do app nos cards ficam
 *   escondidos);
 * - mostra uma peca por vez, com "Peca X de N", miniaturas, Anterior/Proxima,
 *   o preco da peca no kit e os links de tamanho;
 * - troca as listas suspensas do app por bolinhas de cor e botoes de tamanho
 *   (a lista continua por baixo, fazendo o trabalho);
 * - como na proposta, pede o tamanho de cada peca: o que o app ja traz marcado
 *   fica apagado ("TAMANHO: escolha") e a "Proxima peca" so libera depois do
 *   clique. Assim ninguem leva tres PP sem perceber;
 * - mostra o resumo do kit, o preco do topo, a parcela, o aviso de estoque e a
 *   barra fixa do celular.
 * Quem escolhe a variante, calcula o preco e poe na sacola continua sendo o
 * app: o botao final so clica no "Comprar" do tema, que o app intercepta. O
 * desconto e calculado pela Shopify no servidor (funcao de desconto do app);
 * nada aqui decide preco.
 *
 * O app nao redesenha o widget a cada clique (troca classes, textos e a foto
 * da linha), mas pode redesenhar em outras situacoes. Por isso tudo que este
 * script poe la dentro e refeito sempre que some, e cada sincronizacao so
 * escreve no DOM quando o valor muda (senao o MutationObserver entraria em
 * laco).
 *
 * Sem este script, ou se o app mudar a estrutura, o widget continua de pe com
 * os textos do app, todas as pecas a vista e o "Comprar" do tema no lugar.
 */
if (!customElements.get("bs-bundlex-kit")) {
  const UI = "bs-bx-ui";

  const ICONS = {
    prev: '<svg class="bs-bx-nav__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
    next: '<svg class="bs-bx-nav__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    check: '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  };

  /* Mensagens que o app escreve em ingles quando a oferta nao tem traducao
     propria no Bundlex. Cada uma vira o texto que o tema ja mostra no mesmo
     caso ("Esgotado", "Nao ha itens suficientes..."). Texto traduzido no app
     nao casa com estes padroes e fica como veio. */
  const APP_MESSAGES = [
    [/^Not enough items in stock \((\d+) available\)$/, "stockLeft"],
    [/^Selected item is unavailable$/, "soldOut"],
    [/^One or more selected items are unavailable$/, "kitUnavailable"],
    [/^Not enough items in stock\. Please select a smaller bundle or different variant\.$/, "kitStock"],
    [/^Please choose all bundle products$/, "bundleIncomplete"],
    [/^Failed to add items to cart$/, "cartError"],
  ];
  const APP_UNAVAILABLE = /^(?:(.+) - )?Unavailable$/;
  const COLOR_OPTION = /^(cor|cores|color|colour)$/i;

  const create = (tag, className, html) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (html) el.innerHTML = html;
    return el;
  };
  const setText = (el, text) => {
    if (el && el.textContent !== text) el.textContent = text;
  };
  const setAttr = (el, name, value) => {
    if (!el) return;
    if (value === null) {
      if (el.hasAttribute(name)) el.removeAttribute(name);
    } else if (el.getAttribute(name) !== value) {
      el.setAttribute(name, value);
    }
  };
  /* Sempre com booleano: classList.toggle(nome, undefined) inverte a classe em
     vez de tira-la, e a miniatura da peca do kit piscava entre cheia e vazia a
     cada sincronizacao (15/10/2026). */
  const toggle = (el, className, on) => {
    const force = Boolean(on);
    if (el && el.classList.contains(className) !== force) el.classList.toggle(className, force);
  };
  const isOwn = (node) => {
    const el = node && (node.nodeType === 1 ? node : node.parentElement);
    return Boolean(el && el.closest("." + UI));
  };

  /* A foto que o app usa na linha vem cortada em 48x48; para a miniatura 2:3
     pede a mesma foto inteira, so mais larga. */
  const fullImage = (src) => {
    if (!src) return "";
    const [base, query = ""] = src.split("?");
    const params = new URLSearchParams(query);
    params.delete("height");
    params.delete("crop");
    params.set("width", "240");
    return base + "?" + params.toString();
  };

  class BsBundlexKit extends HTMLElement {
    connectedCallback() {
      this.offerKey = null;
      this.saved = new Map();
      this.resetKit();
      this.pending = false;
      this.strings = this.readStrings();

      /* O widget normalmente nasce aqui dentro (o app embed aponta para a
         ancora .bs-bx-anchor), mas pode nascer junto do "Comprar" se esse
         ajuste do app for limpo. Por isso tudo e procurado na coluna de info. */
      this.scope = this.closest(".m-product-info--wrapper") || this;

      this.onClick = this.onClick.bind(this);
      this.onGuard = this.onGuard.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onKeyup = () => this.schedule();
      this.scope.addEventListener("click", this.onGuard, true);
      this.scope.addEventListener("click", this.onClick);
      this.scope.addEventListener("change", this.onChange);
      this.scope.addEventListener("keyup", this.onKeyup);

      this.observer = new MutationObserver((records) => {
        if (records.every((record) => this.isOwnRecord(record))) return;
        this.schedule();
      });
      this.observer.observe(this.scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "src", "aria-checked"],
      });

      /* O bloco de preco do tema e redesenhado na troca de variante e pelo
         proprio app; o preco do kit, a parcela e o selo precisam ser refeitos
         depois disso. */
      this.priceBlock = this.scope.querySelector(".main-product__block-price");
      if (this.priceBlock) {
        this.priceObserver = new MutationObserver((records) => {
          if (records.every((record) => this.isOwnRecord(record))) return;
          this.schedule();
        });
        this.priceObserver.observe(this.priceBlock, { childList: true, subtree: true, characterData: true });
      }

      this.schedule();

      /* A reserva de espaco (bs-bx--reserve) some quando o widget monta. Se ele
         nao montar (oferta pausada, por exemplo), nao pode ficar um buraco. */
      setTimeout(() => this.classList.remove("bs-bx--reserve"), 8000);
    }

    disconnectedCallback() {
      this.scope.removeEventListener("click", this.onGuard, true);
      this.scope.removeEventListener("click", this.onClick);
      this.scope.removeEventListener("change", this.onChange);
      this.scope.removeEventListener("keyup", this.onKeyup);
      if (this.observer) this.observer.disconnect();
      if (this.priceObserver) this.priceObserver.disconnect();
      document.querySelectorAll(".m-sticky-addtocart ." + UI).forEach((el) => el.remove());
      document.documentElement.removeAttribute("data-bs-kit-units");
    }

    readStrings() {
      try {
        return JSON.parse(this.dataset.strings || "{}");
      } catch (error) {
        return {};
      }
    }

    t(key, values) {
      let text = this.strings[key] || "";
      Object.entries(values || {}).forEach(([name, value]) => {
        text = text.split("[" + name + "]").join(value);
      });
      return text;
    }

    isOwnRecord(record) {
      if (record.type === "attributes" || record.type === "characterData") return isOwn(record.target);
      const nodes = [...record.addedNodes, ...record.removedNodes];
      return nodes.length > 0 && nodes.every((node) => isOwn(node) || (node.nodeType === 1 && node.classList.contains(UI)));
    }

    schedule() {
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => {
        this.pending = false;
        this.sync();
      });
    }

    /* As pecas da oferta ativa. No kit da mesma peca, cada linha de cor e
       tamanho; no pacote, cada produto (item, com a linha dele dentro). O
       "painel" e onde o passo a passo mora: a caixa de variantes da oferta ou
       o bloco de produtos do pacote. */
    get state() {
      const widget = this.scope.querySelector(".bx-widget");
      const active = widget && widget.querySelector(".bx-offer-wrap.bx-active");
      const bundle = active && active.querySelector(".bx-offer-main > .bx-bundle-products");
      let pieces = [];
      if (bundle) {
        /* Produto que a cliente ainda precisa escolher numa lista do app
           (espaco "Escolher produto", .bx-bundle-empty) tambem e uma peca, sem
           linha de cor e tamanho ate a escolha. */
        pieces = Array.from(bundle.children)
          .filter((item) => item.classList.contains("bx-cross-sell-item"))
          .map((item) => ({ item, group: item.querySelector(".bx-variant-group"), empty: Boolean(item.querySelector(".bx-bundle-empty")) }));
      } else if (active) {
        pieces = Array.from(active.querySelectorAll(".bx-variant-group")).map((group) => ({ item: null, group, empty: false }));
      }
      const groups = pieces.map((piece) => piece.group);
      const panel = bundle || (active && active.querySelector(".bx-offer-variants-wrap .bx-variants"));
      return { widget, active, bundle, pieces, groups, panel };
    }

    /* Cada oferta guarda a propria montagem: peca atual, ate onde a cliente ja
       chegou e quais pecas ja tem tamanho escolhido. Voltar para uma oferta
       devolve o kit como estava. */
    resetKit() {
      this.step = 0;
      this.reached = 0;
      this.confirmed = new Set();
    }

    useOffer(key) {
      if (key === this.offerKey) return;
      if (this.offerKey !== null) {
        this.saved.set(this.offerKey, { step: this.step, reached: this.reached, confirmed: this.confirmed });
      }
      this.offerKey = key;
      const saved = this.saved.get(key);
      if (saved) {
        this.step = saved.step;
        this.reached = saved.reached;
        this.confirmed = saved.confirmed;
      } else {
        this.resetKit();
      }
    }

    /* A ultima opcao da linha (o tamanho, nas pecas da loja) e a que pede o
       clique; a cor ja vem marcada, como na proposta. Com a lista suspensa do
       app, a opcao e a copia em botoes (.bs-bx-proxy, que tambem e um
       .bx-swatch-group). */
    choiceGroup(group) {
      const options = group.querySelectorAll(".bx-swatch-group, .bx-select");
      return options.length ? options[options.length - 1] : null;
    }

    choiceUnavailable(group) {
      const choice = this.choiceGroup(group);
      if (!choice) return false;
      if (choice.tagName === "SELECT") {
        const option = choice.selectedOptions[0];
        return Boolean(option && option.textContent.trim() !== option.value);
      }
      const active = choice.querySelector(".bx-swatch--active");
      return Boolean(active && active.classList.contains("bx-swatch--unavailable"));
    }

    firstOpen(count) {
      for (let index = 0; index < count; index++) {
        if (!this.confirmed.has(index)) return index;
      }
      return count;
    }

    /* A oferta que o app imprime no bloco (o mesmo JSON que ele usa). Dele
       saem a quantidade de cada oferta (quantity_threshold) e as cores
       cadastradas no app para as bolinhas. */
    discountData(widget) {
      if (this.discount !== undefined) return this.discount;
      this.discount = null;
      const container = widget.closest(".bx-widget-container");
      const settings = this.scope.querySelector(".bx-widget-settings[data-bx-backend-data]");
      try {
        const data = JSON.parse(settings.dataset.bxBackendData);
        const id = container && container.dataset.bxDiscountId;
        this.discount = data.discounts.find((item) => String(item.id) === String(id)) || data.discounts[0] || null;
      } catch (error) {
        this.discount = null;
      }
      return this.discount;
    }

    offerQuantities(widget) {
      const discount = this.discountData(widget);
      return discount && discount.offers ? discount.offers.map((offer) => Number(offer.quantity_threshold) || 0) : [];
    }

    offerData(widget, index) {
      const discount = this.discountData(widget);
      return (discount && discount.offers && discount.offers[index]) || null;
    }

    swatchColor(name, value) {
      const swatches = (this.discount && this.discount.variants && this.discount.variants.swatches) || [];
      const option = swatches.find((item) => String(item.option_name || "").toLowerCase() === name.toLowerCase());
      const entry = option && option.values && option.values[value];
      return (entry && entry.color) || "";
    }

    offerInfo(wrap, index, widget) {
      const read = (selector) => {
        const el = wrap.querySelector(".bx-offer-prices " + selector);
        return el ? el.textContent.trim() : "";
      };
      const was = read(".bx-original-price");
      const now = read(".bx-discounted-price");
      const wasCents = this.cents(was);
      const nowCents = this.cents(now);
      const key = Number(wrap.dataset.offerKey);
      const position = Number.isFinite(key) ? key : index;
      /* No pacote, a quantidade e a de produtos; o app diz 1 para a oferta. */
      const bundleItems = wrap.querySelectorAll(".bx-offer-main > .bx-bundle-products > .bx-cross-sell-item").length;
      const units =
        bundleItems ||
        this.offerQuantities(widget)[position] ||
        wrap.querySelectorAll(".bx-variant-group").length ||
        1;
      const percent = wasCents > nowCents && nowCents > 0 ? Math.round((1 - nowCents / wasCents) * 100) : 0;
      /* "Compre X, ganhe Y" (bxgy no app): quantity_threshold e o total de
         pecas e discount_amount, quantas saem de graca (as de menor preco). */
      const offer = bundleItems ? null : this.offerData(widget, position);
      const free = offer && offer.discount_method === "bxgy" ? Math.min(Math.max(Number(offer.discount_amount) || 0, 0), units - 1) : 0;
      return { units, was, now, wasCents, nowCents, percent, free, bogo: free > 0, bundle: bundleItems > 0 };
    }

    /* "Leve 2, pague 1" no lugar de "Kit 2 pecas" e "1 gratis" no lugar do
       "% OFF" quando a oferta e "Compre X, ganhe Y". */
    kitName(info) {
      return info.bogo
        ? this.t("bogoTitle", { total: String(info.units), paid: String(info.units - info.free) })
        : this.t("kitTitle", { quantity: String(info.units) });
    }

    kitBadge(info) {
      if (info.bogo) return this.t("bogoFree", { count: String(info.free) });
      return info.percent > 0 ? this.t("off", { percent: String(info.percent) }) : "";
    }

    sync() {
      const { widget, active, pieces, groups, panel } = this.state;
      if (!widget) return;

      this.discountData(widget);
      const count = pieces.length;
      const isKit = count > 1;
      this.useOffer(active ? active.dataset.offerKey || "" : null);

      if (this.classList.contains("bs-bx--reserve")) this.classList.remove("bs-bx--reserve");
      this.syncMessages(widget);
      setAttr(widget, "data-bs-units", String(count));
      setAttr(document.documentElement, "data-bs-kit-units", isKit ? String(count) : null);
      this.syncSelectProxies(groups);

      pieces.forEach((piece, index) => {
        const group = piece.group;
        /* Produto ainda nao escolhido na lista do app: a peca fica em aberto. */
        if (piece.empty || !group) {
          if (piece.empty) this.confirmed.delete(index);
          else this.confirmed.add(index);
          return;
        }
        /* Linha sem nada para escolher (produto de variante unica) ja conta
           como escolhida. */
        if (!this.choiceGroup(group)) this.confirmed.add(index);
        /* Trocou a cor e o tamanho escolhido nao existe nela: a peca volta a
           pedir o tamanho, em vez de travar no "Adicionar". */
        if (isKit && this.confirmed.has(index) && this.choiceUnavailable(group)) this.confirmed.delete(index);
      });
      const open = this.firstOpen(count);
      this.step = Math.min(Math.max(this.step, 0), Math.max(Math.min(open, count - 1), 0));
      this.reached = Math.min(Math.max(this.reached, this.step), Math.max(count - 1, 0));
      let done = 0;
      for (let index = 0; index < count; index++) if (this.confirmed.has(index)) done++;
      const kit = { isKit, count, open, done, allDone: open >= count };

      const offers = Array.from(widget.querySelectorAll(".bx-offers > .bx-offer-wrap"));
      const info = active ? this.offerInfo(active, offers.indexOf(active), widget) : null;

      this.syncHeader(widget, info);
      this.syncCards(widget, offers);
      this.syncLabels(groups, kit);
      pieces.forEach((piece, index) => {
        const current = isKit && index === this.step;
        toggle(piece.group, "bs-bx-current", current);
        if (piece.item) toggle(piece.item, "bs-bx-current", current);
        /* Aviso de estoque que so existe por causa do tamanho que o app marcou
           nas pecas ainda sem escolha fica escondido (ver hasError). */
        if (piece.group) toggle(piece.group, "bs-bx-stock-ok", isKit && this.confirmed.has(index) && this.appError(piece.group) && !this.hasError(index, pieces));
      });

      if (panel) {
        if (isKit) {
          this.syncSteps(panel, pieces, kit);
          this.syncPiece(panel, pieces, info);
          this.syncNav(panel, pieces, kit);
        }
        this.syncSizeLinks(panel, pieces);
      }
      this.syncSummary(widget, pieces, info, kit);
      this.syncSticky(pieces, info, kit);
      this.syncPrice(info, kit);
      this.syncGallery(pieces, isKit);
      this.syncThemeVariant(pieces, isKit);
    }

    /* Erros de estoque e da sacola (.bx-variant-error, .bx-error) e o
       "Unavailable" das opcoes em portugues. O app escreve esses textos com
       textContent, o que o observer ve; a troca acontece antes da tela pintar. */
    syncMessages(widget) {
      const container = widget.closest(".bx-widget-container") || widget;
      container.querySelectorAll(".bx-variant-error, .bx-error").forEach((el) => {
        const text = el.textContent.trim();
        if (!text) {
          setAttr(el, "data-bs-available", null);
          return;
        }
        for (const [pattern, key] of APP_MESSAGES) {
          const match = text.match(pattern);
          if (match) {
            setText(el, this.t(key, { quantity: match[1] || "" }));
            /* Guarda o estoque do aviso para o hasError contar so as pecas ja
               escolhidas. */
            setAttr(el, "data-bs-available", key === "stockLeft" ? match[1] : null);
            return;
          }
        }
      });
      widget.querySelectorAll("select option, .bx-extra-options-unavailable, .bx-gift-card-unavailable").forEach((el) => {
        const match = el.textContent.trim().match(APP_UNAVAILABLE);
        if (match) setText(el, (match[1] ? match[1] + " - " : "") + this.t("optionUnavailable"));
      });
    }

    /* "COMPRE EM KIT: 3 PECAS · 10% OFF" no lugar do cabecalho do app. Se a
       oferta tiver "Texto do cabecalho" preenchido no app (header_text, que o
       app imprime em .bx-header e traduz), vale o texto dela, inteiro: e por
       ali que a loja escreve "Leve o conjunto com desconto" em cada oferta. */
    syncHeader(widget, info) {
      const offers = widget.querySelector(".bx-offers");
      if (!offers) return;
      let header = widget.querySelector(":scope > .bs-bx-header");
      if (!header) header = create("p", "bs-bx-header " + UI, "<strong></strong><span></span>");
      if (offers.previousElementSibling !== header) offers.before(header);

      const appHeader = widget.querySelector(":scope > .bx-header");
      const custom = appHeader ? appHeader.textContent.replace(/\s+/g, " ").trim() : "";
      let value = "";
      if (!custom && info) {
        if (info.bogo) {
          value = this.kitName(info);
        } else {
          value = info.units > 1 ? this.t("pieces", { quantity: String(info.units) }) : this.t("onePiece");
          if (info.units > 1 && info.percent > 0) value += " · " + this.kitBadge(info);
        }
      }
      setText(header.firstElementChild, custom || this.t("headerLabel"));
      setText(header.lastElementChild, value);
      toggle(header, "is-custom", Boolean(custom));
    }

    /* Cards: "1 peca / R$ 199,00/un" e "Kit 3 pecas / R$ 179,10/un", com o
       preco por unidade em destaque, como na Insider (BES-219). O selo "10% OFF"
       fica no canto do card (CSS). No pacote de produtos diferentes vai o total
       do kit: as pecas tem precos diferentes e "por unidade" nao diz nada. */
    syncCards(widget, offers) {
      offers.forEach((wrap, index) => {
        const items = wrap.querySelector(".bx-offer-main > .bx-offer-items") || wrap.querySelector(".bx-offer-items");
        if (!items) return;
        let card = items.querySelector(":scope > .bs-bx-card");
        if (!card) {
          card = create(
            "span",
            "bs-bx-card " + UI,
            '<span class="bs-bx-card__title"></span><span class="bs-bx-card__off"></span><span class="bs-bx-card__sub"></span>'
          );
          items.prepend(card);
        }
        const info = this.offerInfo(wrap, index, widget);
        const isKit = info.units > 1;
        const unit = info.nowCents > 0 ? Math.round(info.nowCents / info.units) : 0;
        setText(card.querySelector(".bs-bx-card__title"), isKit ? this.kitName(info) : this.t("onePiece"));
        setText(card.querySelector(".bs-bx-card__off"), this.kitBadge(info));
        setText(card.querySelector(".bs-bx-card__sub"), !info.bundle && unit ? this.t("perUnit", { price: this.money(unit) }) : info.now);
        toggle(card, "is-kit", isKit);
      });
    }

    optionNames(group) {
      const box = group.closest(".bx-variants");
      const title = box && box.querySelector(".bx-variants-title");
      return title ? title.textContent.split(",").map((name) => name.trim()) : [];
    }

    /* Lista suspensa do app (oferta configurada como "dropdown") vira bolinhas
       de cor e botoes de tamanho, com as mesmas classes dos do app para pegar
       o mesmo visual. A lista continua sendo a fonte: o clique escolhe o valor
       nela e avisa o app (evento change), e o estado de cada botao e lido de
       volta dela. Cor sem codigo cadastrado no app vira botao com o nome. */
    syncSelectProxies(groups) {
      groups.filter(Boolean).forEach((group) => {
        const names = this.optionNames(group);
        group.querySelectorAll(".bx-variant-selects > select.bx-select").forEach((select) => {
          const col = select.dataset.col || "0";
          const holder = select.parentElement;
          let proxy = holder.querySelector(`:scope > .bs-bx-proxy[data-bs-col="${col}"]`);
          if (!proxy) {
            proxy = create("div", "bx-swatch-group bs-bx-proxy " + UI);
            proxy.dataset.bsCol = col;
          }
          /* Ordem: lista, rotulo ("COR: KANGRA", do syncLabels) e os botoes. */
          const label = select.nextElementSibling;
          const anchor = label && label.classList.contains("bs-bx-label") ? label : select;
          if (anchor.nextElementSibling !== proxy) anchor.after(proxy);

          const name = names[Number(col)] || "";
          const options = Array.from(select.options);
          const colors = COLOR_OPTION.test(name) ? options.map((option) => this.swatchColor(name, option.value)) : [];
          const asColor = colors.length > 0 && colors.every(Boolean);
          const signature = (asColor ? "cor:" : "botao:") + options.map((option) => option.value).join("|");
          if (proxy.dataset.bsSignature !== signature) {
            proxy.innerHTML = "";
            options.forEach((option, index) => {
              const button = create("button", "bx-swatch " + (asColor ? "bx-swatch--color" : "bx-swatch--pill"));
              button.type = "button";
              button.dataset.value = option.value;
              button.dataset.bsCol = col;
              if (asColor) {
                button.style.setProperty("--bx-swatch-color", colors[index]);
                button.setAttribute("aria-label", option.value);
                button.title = option.value;
              } else {
                button.textContent = option.value;
              }
              proxy.append(button);
            });
            proxy.dataset.bsSignature = signature;
            toggle(proxy, "bx-swatch-group--pill", !asColor);
          }

          Array.from(proxy.children).forEach((button) => {
            const option = options.find((item) => item.value === button.dataset.value);
            const active = select.value === button.dataset.value;
            toggle(button, "bx-swatch--active", active);
            toggle(button, "bx-swatch--unavailable", !option || option.textContent.trim() !== option.value);
            setAttr(button, "aria-pressed", active ? "true" : "false");
          });
        });
      });
    }

    /* "COR: KANGRA" acima de cada grupo. O nome da opcao vem do titulo que o
       proprio app imprime ("Cor, Tamanho"); o valor, do botao marcado. Na peca
       do kit ainda sem tamanho escolhido, o valor e "escolha" e o tamanho que o
       app marcou fica apagado (bs-bx-pending). Tamanho esgotado numa peca do
       kit fica travado (aria-disabled; o clique para no onGuard). */
    syncLabels(groups, kit) {
      groups.forEach((group, index) => {
        if (!group) return;
        const names = this.optionNames(group);
        const pending = kit.isKit && !this.confirmed.has(index);
        const choice = this.choiceGroup(group);
        toggle(group, "bs-bx-pending", pending);

        group.querySelectorAll(".bx-swatch-group").forEach((swatchGroup, optionIndex) => {
          const isChoice = swatchGroup === choice;
          toggle(swatchGroup, "bs-bx-choice", isChoice);

          let label = swatchGroup.previousElementSibling;
          if (!label || !label.classList.contains("bs-bx-label")) {
            label = create("p", "bs-bx-label " + UI, "<strong></strong><span></span>");
            swatchGroup.before(label);
          }
          const selected = swatchGroup.querySelector(".bx-swatch--active");
          setText(label.firstElementChild, names[optionIndex] ? names[optionIndex] + ":" : "");
          setText(label.lastElementChild, pending && isChoice ? this.t("choose") : selected ? selected.dataset.value || "" : "");

          swatchGroup.querySelectorAll(".bx-swatch").forEach((swatch) => {
            const locked = kit.isKit && isChoice && swatch.classList.contains("bx-swatch--unavailable");
            setAttr(swatch, "aria-disabled", locked ? "true" : null);
          });
        });

        /* Rotulo que ficou sem grupo logo depois (o app redesenhou) sai. */
        group.querySelectorAll(".bs-bx-label").forEach((label) => {
          const next = label.nextElementSibling;
          if (!next || !next.classList.contains("bx-swatch-group")) label.remove();
        });
      });
    }

    chooseHint(group, piece, number) {
      if (piece && piece.empty) return this.t("choosePiece", { number: String(number) });
      const names = group ? this.optionNames(group) : [];
      const name = names[names.length - 1] || "";
      return /tamanho|size/i.test(name) ? this.t("chooseSize") : this.t("chooseOption");
    }

    values(group) {
      if (!group) return [];
      return Array.from(group.querySelectorAll(".bx-swatch-group .bx-swatch--active"))
        .map((button) => button.dataset.value)
        .filter(Boolean);
    }

    get productTitle() {
      const title = this.scope.querySelector(".main-product__block-title h1, .main-product__block-title .m-product-title");
      return title ? title.textContent.trim() : "";
    }

    pieceTitle(index, pieces) {
      const piece = pieces[index];
      if (piece && piece.empty) return "";
      const title = piece && piece.item && piece.item.querySelector(".bx-offer-title");
      return title ? title.textContent.trim() : this.productTitle;
    }

    /* "Kangra · P" no kit da mesma peca; com o nome na frente no pacote, onde
       cada peca e um produto ("Calca Wide Leg · Trufa · M"). */
    pieceLabel(index, pieces, values) {
      const parts = pieces[index] && pieces[index].item ? [this.pieceTitle(index, pieces), ...values] : values;
      return parts.filter(Boolean).join(" · ");
    }

    pieceKey(index, pieces) {
      return [this.pieceTitle(index, pieces), ...this.values(pieces[index].group)].join(" / ");
    }

    /* Foto da peca: a do produto no pacote (o app troca pela da cor); no kit,
       a da linha, quando o app mostra; senao, a foto principal do produto. */
    pieceImage(index, pieces) {
      const piece = pieces[index];
      if (piece.empty) return "";
      const img = piece.item ? piece.item.querySelector("img.bx-offer-image") : piece.group.querySelector(".bx-variant-select-image");
      const src = img ? img.getAttribute("src") : "";
      if (src) return fullImage(src);
      /* Kit da mesma peca sem "Mostrar imagem da variante" no app: a foto e a
         da variante da cor escolhida, dos dados que o tema poe na PDP
         (product-data.liquid). Antes ficava sempre a foto principal, e trocar
         a cor nao mudava a miniatura. */
      if (!piece.item) {
        const variantSrc = this.variantImage(this.values(piece.group));
        if (variantSrc) return fullImage(variantSrc);
      }
      if (this.fallbackImage === undefined) {
        const meta = document.querySelector('meta[property="og:image"]');
        this.fallbackImage = meta ? fullImage(meta.content) : "";
      }
      return this.fallbackImage;
    }

    /* Produto da PDP como o tema o descreve (window._themeProducts, do
       product-data.liquid), com a foto de cada variante. */
    themeProduct() {
      if (this.productData) return this.productData;
      const products = window._themeProducts || {};
      const info = this.closest("product-info");
      const handle = info && info.dataset.productHandle;
      const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      const product =
        (handle && Object.values(products).find((item) => item && item.handle === handle)) || (meta && products[meta.id]) || null;
      if (product) this.productData = product;
      return product;
    }

    colorIndex(product) {
      const names = ((product && product.options) || []).map((option) => option.name || option);
      return Math.max(names.findIndex((name) => COLOR_OPTION.test(String(name))), 0);
    }

    /* Foto da variante com as opcoes escolhidas; sem ela, a de qualquer
       variante da mesma cor (as fotos sao por cor). */
    variantImage(values) {
      const product = this.themeProduct();
      if (!product || !values.length) return "";
      const variants = (product.variants || []).filter((variant) => variant.featured_image && variant.featured_image.src);
      const exact = variants.find((variant) => values.every((value, index) => variant.options[index] === value));
      if (exact) return exact.featured_image.src;
      const colorIndex = this.colorIndex(product);
      const color = values[colorIndex];
      const sameColor = variants.find((variant) => variant.options[colorIndex] === color);
      return sameColor ? sameColor.featured_image.src : "";
    }

    /* Galeria da PDP pela cor das bolinhas do app (pedido de 15/10/2026). Com
       o widget, o seletor do tema fica escondido, e so ele trocava as fotos.
       Aqui a cor da peca em montagem (ou da oferta de 1 peca) vai para a mesma
       funcao do tema (updateMedia do product-info), so quando a cor muda:
       trocar o tamanho nao volta a galeria para a primeira foto. Peca de outro
       produto no pacote nao mexe na galeria. */
    syncGallery(pieces, isKit) {
      const index = isKit ? this.step : 0;
      const piece = pieces[index];
      if (!piece || piece.empty || !piece.group) return;
      if (piece.item && this.pieceTitle(index, pieces) !== this.productTitle) return;
      const info = this.closest("product-info");
      const product = this.themeProduct();
      if (!info || typeof info.updateMedia !== "function" || !product) return;
      const variant = this.galleryVariant(this.values(piece.group), info, product);
      if (!variant) return;
      const colorIndex = this.colorIndex(product);
      if (this.galleryColor === undefined) {
        /* Ao abrir, a galeria ja esta na variante do tema. */
        const current = info.currentVariant;
        this.galleryColor = current && current.options ? String(current.options[colorIndex]) : null;
      }
      const color = String(variant.options[colorIndex]);
      if (color === this.galleryColor) return;
      this.galleryColor = color;
      try {
        info.updateMedia(variant);
      } catch (error) {
        /* A galeria fica como estava; o kit segue funcionando. */
      }
    }

    /* Na oferta de 1 peca, a cor e o tamanho escolhidos aqui passam para o
       tema: o ?variant= da URL, o id do formulario e o botao ("Comprar" ou
       "Esgotado"). Com o widget o seletor do tema fica escondido, e o tema
       seguia na variante com que a pagina abriu: o botao dizia "Esgotado" num
       tamanho com estoque, e o "Avise-me" do app Essential Preorder, que le o
       ?variant= da URL (ou o atributo value do id do formulario), nao aparecia
       no tamanho esgotado ou avisaria o tamanho do link (BES-222). Usa as funcoes do
       proprio product-info, mas nao o fluxo inteiro de troca de variante: ele
       buscaria a secao de novo e voltaria a galeria para a primeira foto a
       cada tamanho (a galeria segue a cor no syncGallery). No kit de 2 ou 3
       pecas o tema fica como esta: o aviso de reposicao nao vale para kit. */
    syncThemeVariant(pieces, isKit) {
      if (isKit) return;
      const piece = pieces[0];
      if (!piece || piece.item || !piece.group) return;
      const info = this.closest("product-info");
      const product = this.themeProduct();
      if (!info || !product || typeof info.toggleAddButton !== "function") return;
      const values = this.values(piece.group);
      if (!values.length || values.length !== (product.options || []).length) return;
      const variant = (product.variants || []).find((item) => values.every((value, index) => item.options[index] === value));
      if (!variant) return;
      if (this.themeVariantId === undefined) {
        this.themeVariantId = info.currentVariant ? Number(info.currentVariant.id) : null;
      }
      if (Number(variant.id) === this.themeVariantId) return;
      this.themeVariantId = Number(variant.id);
      try {
        info.currentVariant = variant;
        info.updateURL(info.dataset.url, variant.id);
        info.updateVariantInputs(variant.id);
        document
          .querySelectorAll(`#product-form-${info.dataset.sectionId} input[name="id"], #product-form-installment-${info.dataset.sectionId} input[name="id"]`)
          .forEach((input) => input.setAttribute("value", String(variant.id)));
        info.toggleAddButton(!variant.available, window.MinimogStrings && window.MinimogStrings.soldOut);
      } catch (error) {
        /* O tema fica como estava; o kit segue funcionando. */
      }
    }

    /* Variante com as opcoes escolhidas que a galeria do tema conhece (a
       tabela de fotos por variante do product-info); sem ela, uma da mesma cor. */
    galleryVariant(values, info, product) {
      if (!values.length) return null;
      const data = info.variantGroupImagesData;
      const mapped = data && Array.isArray(data.mapping) ? new Set(data.mapping.map((item) => Number(item.id))) : null;
      const usable = (product.variants || []).filter((variant) => !mapped || mapped.has(Number(variant.id)));
      const exact = usable.find((variant) => values.every((value, position) => variant.options[position] === value));
      if (exact) return exact;
      const colorIndex = this.colorIndex(product);
      return usable.find((variant) => variant.options[colorIndex] === values[colorIndex]) || null;
    }

    /* Preco de cada peca no kit. No pacote, o que o app mostra no produto; no
       kit da mesma peca, o preco da variante (ShopifyAnalytics, que a Shopify
       poe em toda PDP) com a mesma proporcao de desconto da oferta. */
    piecePrices(pieces, info) {
      const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      const variants = (meta && meta.variants) || [];
      const bogo = Boolean(info && info.bogo);
      const ratio = !bogo && info && info.wasCents > 0 && info.nowCents > 0 ? info.nowCents / info.wasCents : 1;
      const prices = pieces.map((piece) => {
        if (piece.item) {
          const read = (selector) => {
            const el = piece.item.querySelector(".bx-offer-prices " + selector);
            return el ? this.cents(el.textContent) : 0;
          };
          const kit = read(".bx-discounted-price");
          return { full: read(".bx-original-price") || kit, kit };
        }
        const variant = variants.find((item) => item.public_title === this.values(piece.group).join(" / "));
        const full = variant ? variant.price : info && info.units ? Math.round((info.wasCents || info.nowCents) / info.units) : 0;
        return { full, kit: Math.round(full * ratio) };
      });
      /* "Compre X, ganhe Y": como na funcao do app, as Y pecas de menor preco
         saem de graca; no empate, as ultimas. */
      if (bogo) {
        prices
          .map((price, index) => ({ price, index }))
          .sort((a, b) => a.price.full - b.price.full || b.index - a.index)
          .slice(0, info.free)
          .forEach(({ price }) => (price.kit = 0));
      }
      return prices;
    }

    /* Erro de estoque da peca. O app soma todas as linhas, inclusive as que
       ainda estao com o tamanho que ele marcou sozinho; aqui so contam as
       pecas ja escolhidas. Ex.: o PP tem 2 e a cliente escolheu PP so na peca
       1; as pecas 2 e 3 seguem no PP do app, mas o aviso ainda nao vale. */
    appError(group) {
      const error = group.querySelector(".bx-variant-error");
      return group.classList.contains("bx-variant-group--unavailable") || Boolean(error && error.textContent.trim());
    }

    hasError(index, pieces) {
      const group = pieces[index] && pieces[index].group;
      if (!group || !this.appError(group)) return false;
      const error = group.querySelector(".bx-variant-error");
      const available = error ? Number(error.dataset.bsAvailable) : 0;
      if (!available) return true;
      const key = this.pieceKey(index, pieces);
      const chosen = pieces.filter((piece, other) => this.confirmed.has(other) && this.pieceKey(other, pieces) === key).length;
      return chosen > available;
    }

    /* Miniaturas como na proposta: peca escolhida com foto e check, peca ainda
       nao alcancada como moldura tracejada com o numero, e travada depois da
       primeira peca sem tamanho. */
    syncSteps(panel, pieces, kit) {
      let steps = panel.querySelector(":scope > .bs-bx-steps");
      if (!steps || steps.querySelectorAll(".bs-bx-thumb").length !== pieces.length) {
        if (steps) steps.remove();
        steps = this.buildSteps(pieces.length);
        panel.prepend(steps);
      }

      const count = steps.querySelector(".bs-bx-steps__count");
      const html = this.t("stepOf", { current: "<strong>" + (this.step + 1) + "</strong>", total: String(pieces.length) });
      if (count.innerHTML !== html) count.innerHTML = html;

      steps.querySelectorAll(".bs-bx-steps__bar").forEach((bar, index) => {
        const done = this.confirmed.has(index);
        toggle(bar, "is-on", done);
        toggle(bar, "is-current", !done && index === this.step);
      });

      steps.querySelectorAll(".bs-bx-thumb").forEach((thumb, index) => {
        const group = pieces[index].group;
        const reached = index <= this.reached;
        const confirmed = this.confirmed.has(index);
        const error = confirmed && this.hasError(index, pieces);
        const img = thumb.querySelector("img");
        const src = this.pieceImage(index, pieces);
        if (src && img.getAttribute("src") !== src) img.setAttribute("src", src);
        toggle(thumb, "is-empty", !reached || pieces[index].empty);
        toggle(thumb, "is-current", index === this.step);
        toggle(thumb, "is-done", confirmed && !error);
        toggle(thumb, "is-error", error);
        setAttr(thumb, "disabled", index > kit.open ? "" : null);
        setAttr(thumb, "aria-current", index === this.step ? "step" : null);
        const values = this.values(group);
        const choice = reached && !pieces[index].empty ? this.pieceLabel(index, pieces, confirmed ? values : values.slice(0, -1)) : this.t("pending");
        setAttr(thumb, "aria-label", this.t("goToItem", { number: String(index + 1) }) + (choice ? ": " + choice : ""));
      });
    }

    buildSteps(total) {
      const steps = create("div", "bs-bx-steps " + UI);
      const top = create("div", "bs-bx-steps__top");
      const title = create("p", "bs-bx-steps__title");
      title.textContent = this.t("title");
      const count = create("p", "bs-bx-steps__count");
      count.setAttribute("aria-live", "polite");
      top.append(title, count);

      const bars = create("div", "bs-bx-steps__bars");
      bars.setAttribute("aria-hidden", "true");
      const thumbs = create("div", "bs-bx-steps__thumbs");

      for (let index = 0; index < total; index++) {
        bars.append(create("span", "bs-bx-steps__bar"));

        const thumb = create("button", "bs-bx-thumb");
        thumb.type = "button";
        thumb.dataset.bsStep = String(index);
        const image = create("span", "bs-bx-thumb__img");
        const img = create("img");
        img.alt = "";
        img.loading = "lazy";
        const number = create("span", "bs-bx-thumb__num");
        number.textContent = String(index + 1);
        number.setAttribute("aria-hidden", "true");
        image.append(img, number, create("span", "bs-bx-thumb__check", ICONS.check));
        const caption = create("span", "bs-bx-thumb__caption");
        caption.textContent = this.t("item", { number: String(index + 1) });
        thumb.append(image, caption);
        thumbs.append(thumb);
      }

      steps.append(top, bars, thumbs);
      return steps;
    }

    /* "PECA 2: LEGGING SOFT SHINE" e "R$ 159,20 no kit (de R$ 199,00)". */
    syncPiece(panel, pieces, info) {
      let piece = panel.querySelector(":scope > .bs-bx-piece");
      if (!piece) {
        piece = create(
          "div",
          "bs-bx-piece " + UI,
          '<p class="bs-bx-piece__title"><strong></strong><span></span></p><p class="bs-bx-piece__price"></p>'
        );
      }
      const steps = panel.querySelector(":scope > .bs-bx-steps");
      if (steps && steps.nextElementSibling !== piece) steps.after(piece);

      const line = this.piecePrices(pieces, info)[this.step];
      let price = "";
      if (line && line.kit) {
        price =
          line.full > line.kit
            ? this.t("inKitFrom", { price: this.money(line.kit), full: this.money(line.full) })
            : this.t("inKit", { price: this.money(line.kit) });
      } else if (line && line.full && info && info.bogo) {
        price = this.t("freeInKit", { full: this.money(line.full) });
      }
      const empty = pieces[this.step] && pieces[this.step].empty;
      const number = String(this.step + 1);
      setText(piece.querySelector(".bs-bx-piece__title strong"), empty ? this.t("choosePiece", { number }) + ":" : this.t("pieceLabel", { number }));
      setText(piece.querySelector(".bs-bx-piece__title span"), this.pieceTitle(this.step, pieces));
      setText(piece.querySelector(".bs-bx-piece__price"), empty ? "" : price);
    }

    /* Anterior / Proxima peca / Adicionar kit, como na proposta: a proxima so
       libera com o tamanho da peca atual escolhido, e o "Adicionar" com todas.
       Erro de estoque nao trava a navegacao (e do kit inteiro: tres pecas iguais
       quando so ha duas, por exemplo, e muitas vezes se resolve trocando outra
       peca); quem barra e o "Adicionar kit", que destaca o aviso. */
    syncNav(panel, pieces, kit) {
      let nav = panel.querySelector(":scope > .bs-bx-nav");
      if (!nav) {
        nav = create("div", "bs-bx-nav " + UI);
        const prev = create("button", "bs-bx-nav__btn bs-bx-nav__btn--prev", ICONS.prev + '<span class="bs-bx-nav__label"></span>');
        const next = create("button", "bs-bx-nav__btn bs-bx-nav__btn--next", '<span class="bs-bx-nav__label"></span>' + ICONS.next);
        const add = create("button", "bs-bx-nav__btn bs-bx-nav__btn--add", '<span class="bs-bx-nav__label"></span>');
        [prev, next, add].forEach((button) => (button.type = "button"));
        prev.setAttribute("aria-label", this.t("previous"));
        prev.querySelector(".bs-bx-nav__label").textContent = this.t("previous");
        nav.append(prev, next, add);
      }
      if (panel.lastElementChild !== nav) panel.append(nav);

      /* Aviso do kit logo acima dos botoes: por que ele nao pode ir para a
         sacola. Aparece assim que o problema surge, e o "Adicionar" com
         problema so o destaca (flashAlert), sem trocar de peca. */
      let alert = panel.querySelector(":scope > .bs-bx-alert");
      if (!alert) {
        alert = create("p", "bs-bx-alert " + UI);
        alert.setAttribute("role", "alert");
      }
      if (nav.previousElementSibling !== alert) nav.before(alert);
      const message = this.kitAlert(pieces);
      setText(alert, message);
      setAttr(alert, "hidden", message ? null : "");

      const isLast = this.step === pieces.length - 1;
      const current = this.confirmed.has(this.step);
      const hint = this.chooseHint(pieces[this.step] && pieces[this.step].group, pieces[this.step], this.step + 1);
      const next = nav.querySelector(".bs-bx-nav__btn--next");
      const add = nav.querySelector(".bs-bx-nav__btn--add");
      setAttr(nav.querySelector(".bs-bx-nav__btn--prev"), "hidden", this.step === 0 ? "" : null);
      setAttr(next, "hidden", isLast ? "" : null);
      setAttr(next, "disabled", current ? null : "");
      setText(next.querySelector(".bs-bx-nav__label"), current ? this.t("next") : hint);
      setAttr(add, "hidden", isLast ? null : "");
      setAttr(add, "disabled", kit.allDone ? null : "");
      setText(add.querySelector(".bs-bx-nav__label"), kit.allDone ? this.t("add") : current ? this.t("completeKit") : hint);
    }

    /* Texto do aviso do kit. Estoque que nao da para as pecas escolhidas
       ("Só temos 1 unidade de Amaranto · P, e você escolheu essa opção em 2
       peças..."), peca esgotada ou, por ultimo, a recusa do proprio app ou da
       sacola (.bx-error, que o app poe no fim do widget, longe do botao). */
    kitAlert(pieces) {
      for (let index = 0; index < pieces.length; index++) {
        if (!this.confirmed.has(index) || !this.hasError(index, pieces)) continue;
        const group = pieces[index].group;
        const variant = this.pieceLabel(index, pieces, this.values(group));
        const error = group.querySelector(".bx-variant-error");
        const available = error ? Number(error.dataset.bsAvailable) : 0;
        if (available) {
          const key = this.pieceKey(index, pieces);
          const chosen = pieces.filter((piece, other) => this.confirmed.has(other) && this.pieceKey(other, pieces) === key).length;
          return this.t(available === 1 ? "stockConflictOne" : "stockConflictOther", {
            count: String(available),
            variant,
            pieces: String(chosen),
          });
        }
        return this.t("pieceSoldOut", { number: String(index + 1), variant });
      }
      const appError = this.scope.querySelector(".bx-widget-container .bx-error");
      return appError ? appError.textContent.trim() : "";
    }

    flashAlert() {
      const alert = this.scope.querySelector(".bx-offer-wrap.bx-active .bs-bx-alert:not([hidden])");
      if (!alert) return;
      alert.classList.remove("is-flash");
      void alert.offsetWidth; // reinicia a animacao
      alert.classList.add("is-flash");
      const rect = alert.getBoundingClientRect();
      const offset = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 0;
      if (rect.top < offset + 8 || rect.bottom > window.innerHeight - 96) {
        const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollBy({ top: rect.top - window.innerHeight / 2, behavior: smooth ? "smooth" : "auto" });
      }
    }

    /* "Encontre o seu tamanho" e "Guia de tamanhos" dentro da caixa. Os
       botoes sao do app do Sizebay, num bloco proprio da PDP; aqui ficam copias
       que clicam nos originais (o bloco original some pelo CSS). Mover o bloco
       do Sizebay para dentro do widget arriscaria perde-lo num redesenho do
       app. O Sizebay mede o produto da pagina, entao no pacote os links so
       aparecem na peca que e esse produto. */
    syncSizeLinks(panel, pieces) {
      const originals = this.sizeButtons();
      let proxy = panel.querySelector(":scope > .bs-bx-sizes");
      const piece = pieces[this.step] || pieces[0];
      const sameProduct = !piece || !piece.item || this.pieceTitle(pieces.indexOf(piece), pieces) === this.productTitle;
      if (!originals.length || !sameProduct) {
        if (proxy) proxy.remove();
        return;
      }
      /* As copias nao levam as classes vfr_* do Sizebay, para o script dele
         nao adota-las (abriria o modal duas vezes); o visual e o mesmo que o
         tema da aos originais. */
      if (!proxy) proxy = create("div", "bs-bx-sizes " + UI);
      if (proxy.children.length !== originals.length) {
        proxy.innerHTML = "";
        originals.forEach((original, index) => {
          const icon = original.querySelector(".vfr_button_icon");
          const label = Array.from(original.children).find((child) => !child.classList.contains("vfr_button_icon"));
          const button = create("button", "bs-bx-sizes__btn");
          button.type = "button";
          button.dataset.bsSize = String(index);
          if (icon) button.append(create("span", "bs-bx-sizes__icon", icon.innerHTML));
          button.append(create("span", "bs-bx-sizes__label"));
          setText(button.lastElementChild, (label ? label.textContent : original.textContent).trim());
          proxy.append(button);
        });
      }
      const below = panel.querySelector(":scope > .bs-bx-alert") || panel.querySelector(":scope > .bs-bx-nav");
      if (below) {
        if (below.previousElementSibling !== proxy) below.before(proxy);
      } else if (panel.lastElementChild !== proxy) {
        panel.append(proxy);
      }
    }

    sizeButtons() {
      const source = this.scope.querySelector(".main-product__block .vfr_buttons_links");
      return source ? Array.from(source.querySelectorAll("button")) : [];
    }

    /* "Seu kit": peca escolhida com nome, cor, tamanho e preco no kit; peca
       ainda nao alcancada como "a escolher". O total e o do app (o kit
       inteiro), e a economia diz "ao completar o kit" enquanto faltar peca. */
    syncSummary(widget, pieces, info, kit) {
      const offers = widget.querySelector(".bx-offers");
      if (!offers) return;

      let summary = widget.querySelector(":scope > .bs-bx-summary");
      if (!summary) {
        summary = create("div", "bs-bx-summary " + UI);
        summary.innerHTML =
          '<p class="bs-bx-summary__title"></p><ol class="bs-bx-summary__list"></ol>' +
          '<div class="bs-bx-summary__total"><span class="bs-bx-summary__label"></span>' +
          '<span class="bs-bx-summary__prices"><s class="bs-bx-summary__was"></s><strong class="bs-bx-summary__now"></strong></span></div>' +
          '<p class="bs-bx-summary__save"></p>';
        summary.querySelector(".bs-bx-summary__title").textContent = this.t("summaryTitle");
        summary.querySelector(".bs-bx-summary__label").textContent = this.t("total");
      }
      if (offers.nextElementSibling !== summary) offers.after(summary);

      setAttr(summary, "hidden", kit.isKit ? null : "");
      if (!kit.isKit || !info) return;

      const list = summary.querySelector(".bs-bx-summary__list");
      while (list.children.length > pieces.length) list.lastElementChild.remove();
      while (list.children.length < pieces.length) {
        list.append(create("li", "bs-bx-summary__item", '<span class="bs-bx-summary__name"></span><span class="bs-bx-summary__price"></span>'));
      }
      const prices = this.piecePrices(pieces, info);
      pieces.forEach((piece, index) => {
        const item = list.children[index];
        const reached = index <= this.reached && !piece.empty;
        const confirmed = this.confirmed.has(index);
        const error = confirmed && this.hasError(index, pieces);
        let name = index + 1 + ". " + this.t("pending");
        let price = "—";
        if (reached) {
          const values = confirmed ? this.values(piece.group) : this.values(piece.group).slice(0, -1);
          name = index + 1 + ". " + [this.pieceTitle(index, pieces), ...values].filter(Boolean).join(" · ");
          if (error) name += " (" + this.t("unavailable") + ")";
          const line = prices[index];
          price = line && line.kit ? this.money(line.kit) : line && line.full && info.bogo ? this.t("free") : "";
        }
        setText(item.firstElementChild, name);
        setText(item.lastElementChild, price);
        toggle(item, "is-pending", !reached);
        toggle(item, "is-error", error);
      });

      setText(summary.querySelector(".bs-bx-summary__was"), info.was);
      setText(summary.querySelector(".bs-bx-summary__now"), info.now);
      const saved = this.money(info.wasCents - info.nowCents);
      const save = info.was && saved ? this.t(kit.allDone ? "savings" : "savingsPending", { amount: saved }) : "";
      setText(summary.querySelector(".bs-bx-summary__save"), save);
    }

    /* Barra fixa (celular): "Kit 3 pecas · peca 2 de 3", o total e o botao do
       passo a passo no lugar do "Adicionar ao carrinho" do tema, que mandaria
       uma peca solta. */
    syncSticky(pieces, info, kit) {
      const holder = document.querySelector(".m-sticky-addtocart .m-sticky-addtocart--rightblock");
      if (!holder) return;
      let sticky = holder.querySelector(":scope > .bs-bx-sticky");
      let cta = holder.querySelector(":scope > .bs-bx-sticky-cta");
      if (!kit.isKit || !info) {
        if (sticky) sticky.remove();
        if (cta) cta.remove();
        return;
      }
      if (!sticky) {
        sticky = create("p", "bs-bx-sticky " + UI, '<span class="bs-bx-sticky__title"></span><strong class="bs-bx-sticky__now"></strong><s class="bs-bx-sticky__was"></s>');
        holder.prepend(sticky);
      }
      if (!cta) {
        cta = create("button", "bs-bx-sticky-cta " + UI);
        cta.type = "button";
        cta.addEventListener("click", () => this.onSticky(cta));
        holder.append(cta);
      }
      setText(sticky.querySelector(".bs-bx-sticky__title"), this.t("stickyLabel", { quantity: String(info.units), current: String(this.step + 1) }));
      setText(sticky.querySelector(".bs-bx-sticky__now"), info.now);
      setText(sticky.querySelector(".bs-bx-sticky__was"), info.was);

      const isLast = this.step === pieces.length - 1;
      const current = this.confirmed.has(this.step);
      const ready = isLast ? kit.allDone : current;
      const hint = this.chooseHint(pieces[this.step] && pieces[this.step].group, pieces[this.step], this.step + 1);
      setText(cta, isLast ? (kit.allDone ? this.t("addShort") : hint) : current ? this.t("next") : hint);
      setAttr(cta, "disabled", ready ? null : "");
    }

    onSticky(cta) {
      const { pieces } = this.state;
      if (pieces.length < 2) return;
      if (this.step === pieces.length - 1) {
        this.addToCart(cta, pieces);
      } else if (this.confirmed.has(this.step)) {
        this.goTo(this.step + 1, true);
      }
    }

    /* Preco do topo com kit, como na proposta A: o total do kit em vinho, o
       "de" riscado e o selo "10% OFF" numa linha propria (bs-bx-top-price),
       porque no pacote o app nao atualiza o preco do tema; o do tema fica
       escondido pelo CSS. Embaixo da parcela, "Kit 3 pecas · 2 de 3
       escolhidas". A conta da parcela e a do product-installments.liquid
       (Tabela Price com juros, divisao simples sem, centavo sempre para cima). */
    syncPrice(info, kit) {
      if (!this.priceBlock) return;

      const holder = this.priceBlock.querySelector(".m-price");
      let row = this.priceBlock.querySelector(".bs-bx-top-price");
      /* Tambem na oferta de 1 peca com desconto (desconto por niveis, ex.: 5%
         na primeira) e no kit sem cor e tamanho por peca no app: o app nao
         atualiza o preco do tema, que ficava cheio enquanto a parcela ja era
         a do desconto. */
      const discounted = Boolean(info && info.wasCents > info.nowCents && info.nowCents > 0);
      if ((kit.isKit || discounted) && info && holder) {
        if (!row) {
          row = create(
            "div",
            "bs-bx-top-price " + UI,
            '<span class="bs-bx-top-price__now"></span><s class="bs-bx-top-price__was"></s><span class="bs-bx-price-off"></span>'
          );
        }
        if (holder.firstElementChild !== row) holder.prepend(row);
        setText(row.querySelector(".bs-bx-top-price__now"), info.now);
        setText(row.querySelector(".bs-bx-top-price__was"), info.wasCents > info.nowCents ? info.was : "");
        setText(row.querySelector(".bs-bx-price-off"), this.kitBadge(info));
      } else if (row) {
        row.remove();
      }

      const group = this.priceBlock.querySelector(".product-block-group--price");
      let note = this.priceBlock.querySelector(":scope > .bs-bx-price-note");
      if (kit.isKit && info && group) {
        if (!note) note = create("p", "bs-bx-price-note " + UI);
        if (group.nextElementSibling !== note) group.after(note);
        const quantity = String(info.units);
        setText(note, kit.allDone ? this.t("kitComplete", { quantity }) : this.t("kitProgress", { quantity, count: String(kit.done) }));
      } else if (note) {
        note.remove();
      }

      const line = this.priceBlock.querySelector(".m-price__installment[data-installments-count]");
      const amount = line && line.querySelector(".m-price__installment-amount");
      const price = info ? info.nowCents : 0;
      const count = line ? Number(line.dataset.installmentsCount) : 0;
      if (!amount || !price || !count) return;

      const rate = (Number(line.dataset.installmentsRate) || 0) / 100;
      let installment = price / count;
      if (rate > 0) {
        const compound = Math.pow(1 + rate, count);
        installment = (price * rate * compound) / (compound - 1);
      }
      setText(amount, this.money(Math.ceil(installment)));
    }

    cents(text) {
      const digits = String(text || "").replace(/[^\d]/g, "");
      return digits ? Number(digits) : 0;
    }

    money(cents) {
      if (!(cents > 0)) return "";
      const format = window.MinimogSettings && window.MinimogSettings.money_format;
      if (typeof window.formatMoney === "function" && format) return window.formatMoney(cents, format);
      return new Intl.NumberFormat(document.documentElement.lang || "pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);
    }

    /* Tamanho esgotado numa peca do kit nao entra: o clique para aqui, na
       captura, antes de chegar ao app. */
    onGuard(event) {
      const swatch = event.target.closest(".bx-swatch[aria-disabled='true']");
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
    }

    /* Botao da copia da lista suspensa: escolhe o valor na lista do app e
       avisa o app, como se a cliente tivesse usado a lista. */
    pickProxy(button) {
      const holder = button.closest(".bx-variant-selects");
      const select = holder && holder.querySelector(`select.bx-select[data-col="${button.dataset.bsCol}"]`);
      if (!select || select.value === button.dataset.value) return;
      select.value = button.dataset.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    /* Clique no tamanho (ou na ultima opcao) de uma peca do kit: a peca passa
       a contar como escolhida. */
    confirmChoice(control) {
      const group = control.closest(".bx-variant-group");
      const active = group && group.closest(".bx-offer-wrap.bx-active");
      if (!active) return;
      this.useOffer(active.dataset.offerKey || "");
      const choice = this.choiceGroup(group);
      if (!choice || !choice.contains(control) || control.getAttribute("aria-disabled") === "true") return;
      const index = this.state.groups.indexOf(group);
      if (index >= 0) this.confirmed.add(index);
    }

    onChange(event) {
      const select = event.target.closest(".bx-select");
      if (select && event.isTrusted) this.confirmChoice(select);
      this.schedule();
    }

    onClick(event) {
      const { pieces } = this.state;
      const swatch = event.target.closest(".bx-swatch");
      const thumb = event.target.closest(".bs-bx-thumb");
      const button = event.target.closest(".bs-bx-nav__btn");
      const sizeLink = event.target.closest(".bs-bx-sizes__btn");

      if (swatch) {
        if (swatch.closest(".bs-bx-proxy")) this.pickProxy(swatch);
        this.confirmChoice(swatch);
        /* O app so limpa o aviso dele ao trocar de oferta ou tentar de novo;
           trocou uma peca, o aviso antigo ja nao vale. */
        const appError = this.scope.querySelector(".bx-widget-container .bx-error");
        if (appError && appError.textContent) appError.textContent = "";
        this.schedule();
      } else if (thumb) {
        if (!thumb.disabled) this.goTo(Number(thumb.dataset.bsStep));
      } else if (sizeLink) {
        const original = this.sizeButtons()[Number(sizeLink.dataset.bsSize)];
        if (original) original.click();
      } else if (button && button.classList.contains("bs-bx-nav__btn--prev")) {
        this.goTo(this.step - 1);
      } else if (button && button.classList.contains("bs-bx-nav__btn--next")) {
        if (this.confirmed.has(this.step)) this.goTo(this.step + 1);
      } else if (button && button.classList.contains("bs-bx-nav__btn--add")) {
        this.addToCart(button, pieces);
      } else {
        this.schedule();
      }
    }

    /* Vai para a peca (nunca alem da primeira sem tamanho) e traz a caixa para
       a tela: pelos botoes de dentro dela, so se o topo saiu por cima; pela
       barra fixa, sempre que ela nao estiver a vista. */
    goTo(step, reveal) {
      const { pieces } = this.state;
      this.step = Math.min(Math.max(step, 0), Math.max(Math.min(this.firstOpen(pieces.length), pieces.length - 1), 0));
      this.sync();
      const { panel } = this.state;
      if (!panel) return;
      const offset = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 0;
      const top = panel.getBoundingClientRect().top - offset - 16;
      if (top < 0 || (reveal && top > window.innerHeight * 0.4)) {
        const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollBy({ top, behavior: smooth ? "smooth" : "auto" });
      }
    }

    /* O "Comprar" do tema continua sendo o caminho para a sacola: o app
       intercepta esse clique e manda as pecas com o desconto. Antes, a peca sem
       tamanho vem para a tela; com erro de estoque, o aviso do kit e destacado
       (e so troca de peca se a atual nao tiver o problema). */
    addToCart(button, pieces) {
      const firstPending = pieces.findIndex((piece, index) => !this.confirmed.has(index));
      if (firstPending >= 0) {
        this.goTo(firstPending, true);
        return;
      }
      const firstError = pieces.findIndex((piece, index) => this.hasError(index, pieces));
      if (firstError >= 0) {
        if (!this.hasError(this.step, pieces)) this.goTo(firstError);
        this.flashAlert();
        return;
      }
      const submit = this.scope.querySelector(".m-product-form--main button[name='add']");
      if (!submit) return;
      button.classList.add("is-loading");
      setTimeout(() => button.classList.remove("is-loading"), 2500);
      submit.click();
    }
  }

  customElements.define("bs-bundlex-kit", BsBundlexKit);
}
